import { LatLngLiteral } from "leaflet"

import { ICoordinates } from "../interfaces/ICoordinates"

export const ToLatLngLiteral = (coords: ICoordinates): LatLngLiteral => ({
    lat: coords.latitude,
    lng: coords.longitude
})